import HydrantMapItemIconModelBase from '../_generated/modelBases/hydrant-map-item-icon-model-base';

export default class HydrantMapItemIconModel extends HydrantMapItemIconModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
